import { useQuery } from '@tanstack/react-query';
import apiClient from '../lib/api-client';

/**
 * Fetch policy details from the server.
 * Endpoint: GET /policy/policy-details?policy_number=...
 */
export default function usePolicyDetails(policyNumber, enabled = false) {
  const isValid = policyNumber && typeof policyNumber === 'string' && policyNumber.trim() !== '';

  return useQuery({
    queryKey: ['policyDetails', policyNumber],
    queryFn: async () => {
      if (!isValid) throw new Error('Invalid or missing policy number');
      const response = await apiClient.get('/policy/policy-details', {
        params: { policy_number: policyNumber },
      });
      return response.data;
    },
    enabled: enabled && isValid,
    retry: (failureCount, error) => {
      if (error?.message === 'Invalid or missing policy number') return false;
      return failureCount < 3;
    },
  });
}
